/* List of Redux constants */
export const VACANCY_CLOSE_INITIATE = '@vacancy-close/initiate';
export const VACANCY_CLOSE_CANCEL = '@vacancy-close/cancel';
export const VACANCY_CLOSE_SET_HIRED_APPLICATIONS = '@vacancy-close/set-hired-applications';
export const VACANCY_CLOSE_SET_HIRED_APPLICATIONS_LOADING = '@vacancy-close/set-hired-applications-loading';
export const VACANCY_CLOSE_SET_ACTIVE_APPLICATIONS_COUNT = '@vacancy-close/set-active-applications-count';
export const VACANCY_CLOSE_SET_ACTIVE_APPLICATIONS_COUNT_LOADING = '@vacancy-close/set-active-applications-loading';
export const VACANCY_CLOSE_SET_CLOSING = '@vacancy-close/set-closing';
export const VACANCY_CLOSE_SET_SUGGESTED_VACANCY = '@vacancy-close/set-suggested-vacancy';
export const VACANCY_CLOSE_RESET_SUGGESTED_VACANCY = '@vacancy-close/reset-suggested-vacancy';

/* List of Sagas constants */
export const VACANCY_CLOSE_GET_HIRED_APPLICATIONS = '@vacancy-close/get-hired-applications';
export const VACANCY_CLOSE_GET_ACTIVE_APPLICATIONS_COUNT = '@vacancy-close/get-active-applications-count';
export const VACANCY_CLOSE_RUN  = '@vacancy-close/run';



// WEBPACK FOOTER //
// ./src/actions/vacancy-close/types.js